import {Component} from '@angular/core';
import {IntroComponent} from './components/intro/intro.component';
import {CompactProjectsComponent} from './components/compact-projects/compact-projects.component';
import {OurSolutionComponent} from './components/our-solution/our-solution.component';
import {DetailedProjectsComponent} from './components/detailed-projects/detailed-projects.component';
import {ServicesComponent} from './components/services/services.component';
import {MidPageCtaComponent} from './components/mid-page-cta/mid-page-cta.component';
import {CustomerVoicesComponent} from './components/customer-voices/customer-voices.component';
import {AboutComponent} from './components/about/about.component';
import {StepsToSuccessComponent} from './components/steps-to-success/steps-to-success.component';
import {CompactStatsComponent} from './components/compact-stats/compact-stats.component';
import {FaqComponent} from '../../shared/components/faq/faq.component';
import {LocationComponent} from '../../shared/components/location/location.component';
import {CtaComponent} from '../../shared/components/cta/cta.component';
import {LogoCloudComponent} from '../../shared/components/logo-cloud/logo-cloud.component';
import {HeroComponent} from './components/hero/hero.component';

@Component({
    selector: 'wci-landing',
    imports: [
        IntroComponent,
        CompactProjectsComponent,
        OurSolutionComponent,
        DetailedProjectsComponent,
        ServicesComponent,
        MidPageCtaComponent,
        CustomerVoicesComponent,
        AboutComponent,
        StepsToSuccessComponent,
        CompactStatsComponent,
        FaqComponent,
        LocationComponent,
        CtaComponent,
        LogoCloudComponent,
        HeroComponent,
    ],
    template: `
        <wci-hero></wci-hero>
        <wci-logo-cloud [highlightedOnly]="true"></wci-logo-cloud>
        <wci-intro></wci-intro>
        <wci-compact-projects></wci-compact-projects>
        <wci-our-solution></wci-our-solution>
        <wci-detailed-projects
            id="projects"></wci-detailed-projects>
        <wci-services id="services"></wci-services>
        <wci-mid-page-cta></wci-mid-page-cta>
        <wci-customer></wci-customer>
        <wci-about id="about"></wci-about>
        <wci-steps-to-success id="how"></wci-steps-to-success>
        <wci-compact-stats></wci-compact-stats>
        <wci-logo-cloud></wci-logo-cloud>
        <wci-faq
            id="faq"
            heading="FAQ - kurz, klar & auf den Punkt."
            subheader="Noch unsicher? Kein Problem - hier beantworten wir die Fragen, die uns am häufigsten gestellt werden. Und wenn deine nicht dabei ist: Einfach kurz schreiben!"
            [items]="faqItems"></wci-faq>
        <wci-location></wci-location>
        <wci-cta></wci-cta>
    `,
    styles: ``,
})
export class LandingComponent {
    faqItems = [
        {
            question: 'Was kostet eine Website?',
            answer: 'Eine pauschale Summe zu nennen wäre unprofessionell, da wir für jedes Projekt einen maßgeschneiderten Plan entwickeln - individuell auf deine Ziele abgestimmt.',
        },
        {
            question: 'Wie lange dauert das Erstellen einer Website?',
            answer: 'Je nach Zielsetzung und Projektumfang variiert der Zeitrahmen. Wichtig ist uns, eine durchdachte und funktionierende Lösung für dein Projekt zu entwickeln. In der Regel dauert es von der Planung bis zum Livegang etwa 4 Wochen.',
        },
        {
            question: 'Muss ich mich nach Abschluss selbst um meine Website kümmern?',
            answer: 'Nein, denn wir sind überzeugt: Jeder sollte das tun, was er am besten kann. Du führst dein Unternehmen - wir übernehmen den Rest online.',
        },
        {
            question: 'Wie viel Zeit muss ich in meine zukünftige Website investieren?',
            answer: 'Dein Zeitaufwand liegt bei maximal 2-3 Stunden.',
        },
        {
            question:
                'Ich finde in euren Referenzen keine Website aus meiner Branche, könnt ihr mir trotzdem helfen?',
            answer: 'Definitiv. Wir lieben Herausforderungen und setzen uns intensiv mit jedem Kunden, seiner Zielgruppe und seinen Zielen auseinander - unabhängig von der Branche.',
        },
    ];
}
